import * as React from "react";
import { forwardRef } from "react";
const SvgChevronNext = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path fill="currentColor" fillRule="nonzero" d="M6.41 2 5 3.41 9.58 8 5 12.59 6.41 14l6-6z" /><path d="M0 0h16v16H0z" /></g></svg>;
const ForwardRef = forwardRef(SvgChevronNext);
export { ForwardRef as ReactComponent };